import axios from "axios";

export const state = {
    expenses: [],
};

export const getters = {
    expenses: state => state.expenses,
};

export const mutations = {
    setExpenses(state, newValue) {
        state.expenses = newValue
    },
};

export const actions = {
    fetchExpenses({ commit }) {
        axios.get('/expenses').then(res => {
            commit('setExpenses', res.data.expenses)
        })
    },
};